var map = {
	"./featured-blogs.de-CH.json": 1247,
	"./featured-blogs.de-DE.json": 1248,
	"./featured-blogs.en-CA.json": 1249,
	"./featured-blogs.en-GB.json": 1250,
	"./featured-blogs.en-IN.json": 1251,
	"./featured-blogs.en-ME.json": 1252,
	"./featured-blogs.en-US.json": 1253,
	"./featured-blogs.es-EM.json": 1254,
	"./featured-blogs.es-ES.json": 1255,
	"./featured-blogs.fr-BE.json": 1256,
	"./featured-blogs.fr-CA.json": 1257,
	"./featured-blogs.fr-CH.json": 1258,
	"./featured-blogs.nl-BE.json": 1259,
	"./featured-blogs.nl-NL.json": 1260,
	"./featured-blogs.pl-PL.json": 1261,
	"./featured-blogs.pt-BR.json": 1262
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1246;